import React, { FC } from "react";
import { Form, Input } from "antd";
import Util from "../../../util/util";
import { IPaymentPageCustomAttribute } from "@app-models";

interface SimpleInputFieldProps {
  name: string;
  attribute: IPaymentPageCustomAttribute;
}

const SimpleInputField: FC<SimpleInputFieldProps> = ({ name, attribute }) => {
  const v = Util.parseValidationValue(attribute);
  const required = { required: attribute.mandatory, message: "Field is mandatory" };
  const isNumber = attribute.validationType === "NUMBER";
  const minLen = v.minLen != null ? Number(v.minLen) : undefined;
  const maxLen = v.maxLen != null && Number(v.maxLen) > 0 ? Number(v.maxLen) : undefined;
  const textLengthRule =
    minLen != null || maxLen != null ? Util.textLengthRule(minLen, maxLen) : null;

  const minValue = attribute.validatedInput && v.minValue != null ? Number(v.minValue) : undefined;
  const maxValue =
    attribute.validatedInput && v.maxValue != null && Number(v.maxValue) > 0
      ? Number(v.maxValue)
      : undefined;

  const rules = isNumber
    ? [required, Util.numberRangeRule(minValue, maxValue)]
    : [required, ...(textLengthRule ? [textLengthRule] : [])];
  const inputProps = isNumber
    ? { type: "number" as const }
    : {
        type: "text" as const,
        minLength: +(v.minLen ?? 0),
        maxLength: v.maxLen != null && +v.maxLen > 0 ? +v.maxLen : 10000,
      };
  return (
    <div className="name-field field-title-case">
      <Form.Item name={name} rules={rules} key={name}>
        <div className="name-field-2">
          <label className="form-label-style">{attribute.fieldName}</label>
          <Input
            className="form-input-style"
            placeholder={attribute.fieldName}
            {...inputProps}
          />
        </div>
      </Form.Item>
    </div>
  );
};

export default SimpleInputField;
